// The row actions sit on the same filled surface the selector pill shows on hover, so they read as one control.
export const selectorActionClassName =
	"bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-750"
